import { makeObservable, action } from "mobx";
import { Client } from '../api';

export default class ClientStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      getClients: action,
      createClient: action,
      getClientById: action,
      getClientByEmail: action,
      updateClientById: action,
      updateClientByEmail: action
    });
  }

  async getClients() {
    try {
      const retObj = await Client.getClients();
      return retObj.data.response.clients;
    } catch (error) {
      console.error("Error in getClients:", error);
      throw error;
    }
  }

  async createClient(data) {
    try {
      const retObj = await Client.createClient(data);
      return retObj.data.response.client;
    } catch (error) {
      console.error("Error in createClient:", error);
      throw error;
    }
  }

  async getClientById(id) {
    try {
      const retObj = await Client.getClientById(id);
      return retObj.data.response.client;
    } catch (error) {
      console.error("Error in getClientById:", error);
      throw error;
    }
  }

  async getClientByEmail(email) {
    try {
      const retObj = await Client.getClientByEmail(email);
      return retObj.data.response.clients;
    } catch (error) {
      console.error("Error in getClientByEmail:", error);
      throw error;
    }
  }

  async updateClientById(id, data) {
    try {
      const retObj = await Client.updateClientById(id, data);
      return retObj.data.response.client;
    } catch (error) {
      console.error("Error in updateClientById:", error);
      throw error;
    }
  }

  async updateClientByEmail(data, email) {
    try {
      const retObj = await Client.updateClientByEmail(data, email);
      return retObj;
    } catch (error) {
      console.error("Error in updateClientByEmail:", error);
      throw error;
    }
  }
}
